export const getYearsAddedToDate = (date, yearsCount) => {
  return new Date(date.setFullYear(date.getFullYear() + yearsCount));
};
